const ChainlinkCnt = {
  symbol: "LINK",
  name: "chainlink",
  meta: {
    title: "Buy chainlink | Buy chainlink | chainlink prices and charts",
    description:
      "China has created a wave of links in the cryptocurrency market and has attracted the attention of large companies such as Google. Experience buying and selling China Link in coinnick Market.",
    keywords: "chainlink, Buy chainlink, Sell chainlink, chainlink Price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه چین لینک بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید چین لینک کنید. قیمت چین لینک در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول چین لینک کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " بهترین کیف پول‌هایی که چین لینک را پشتیبانی می‌کنند عبارتند از: کیف پول سخت افزاری لجر(Ledger) و ترزور (Trezor)، کیف پول های موبایل تراست ولت (Trust Wallet)، اکسودوس (Exodus) و کیف پول‌ تحت وب متامسک (MetaMask).",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین نیک مارکت می‌توانم چین لینک نگهداری کنم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " بله، در کوین‌نیک مارکت یک کیف پول اختصاصی و امن چین لینک دارید، که می‌توانید چین لینک را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا چین لینک ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " چین لینک با برخی از شرکت‌های بزرگ فناوری و مالی که به دنبال گسترش خدمات خود در بازار ارزهای دیجیتال هستند، همکاری می‌کند. به عنوان مثال، چین لینک با SWIFT در حال کار روی یک پروژه بزرگ برای ایجاد زیرساخت برای اتصال سیستم‌های بانکی موجود و قراردادهای هوشمند است. در سال 2019، گوگل اعلام کرد که از گره‌های چین لینک در اپلیکیشن‌های ابری/بلاکچین ساخته شده با اتریوم و Google Cloud استفاده خواهد کرد. فهرست طولانی شرکای چین لینک مانند پولکادات و Synthetix از دنیای ارزهای دیجیتال و همچنین SWIFT و Google از دنیای تجارت سنتی نشان دهنده کاربردهای چین لینک در دنیای واقعی و آینده روشن این پروژه است.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy chainlink?",
      answer:
        "In coinnik Market trading platform, you can buy China link with Shetab member bank card and lowest fee. The price of China Link in coinnik Market is determined by you.",
      id: "toggler1",
    },
    {
      question: "What is the best chainlink wallet?",
      answer: "Chainlink_wallet",
      id: "toggler2",
    },
    {
      question: "Can chainlink be kept at Coinnik Market?",
      answer: "kept_chainlink",
      id: "toggler3",
    },
    {
      question: "Is chainlink Worth the Investment?",
      answer: "Chainlink_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about chainlink",
        subTitle: "What is an chainlink?",
        content: "Chainlink_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of chainlink",
        content: "Chainlink_history_description",
        btnTitle: "Buy and sell chainlink",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell without intermediaries chainlink in coinnik Market",
        subTitle: "Buy chainlink",
        content: "Buy_chainlink_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell chainlink",
        content: "Sell_chainlink_description",
        btnTitle: "Buy and sell chainlink",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest chainlink analysis on the blog",
  informationTitle: "chainlink market statistics and information",
};

export default ChainlinkCnt;
